import React, { PropTypes } from 'react'
import ListEntry from '../../shared/ListEntry'
import ObjectTitle from '../ObjectTitle'
import { getCurrentLanguage } from '../../../localData';
import IconBar from '../IconBar';
import settings from '../../../../config/settings';

const ObjectEntry = ({ object, deleteEntry }) => {
    const entry = {
        id: object.id,
        title: <ObjectTitle object={object} />,
        txt: object.ObjDesigner,
        linkUrl: `/${getCurrentLanguage()}/object/${ object.id }`,
        imageUrl: object.ObjThumbnail,
        deleteEntry: deleteEntry,
        iconBar: !!settings.Object.list.showIconBar && <IconBar object={object} />
    };

    return <ListEntry entry={ entry } />;
};

ObjectEntry.propTypes = {
    object: PropTypes.object.isRequired,
    deleteEntry: PropTypes.func,
};

export default ObjectEntry;


// WEBPACK FOOTER //
// ./app/components/Object/Entry/ObjectEntry.jsx